import { Component, inject } from '@angular/core';
import { DashboardLayoutService } from '../dashboard-layout.service';
import { NavMenuItem } from '../models/nav-menu-item.model';

import { ButtonModule } from 'primeng/button';
import { CommunityResourcesDialogDirective } from '@shared/directives/community-resources-dialog.directive';

@Component({
  selector: 'app-dashboard-layout-sidebar',
  templateUrl: './dashboard-layout-sidebar.component.html',
  styleUrls: ['./dashboard-layout-sidebar.component.scss'],
  imports: [ButtonModule, CommunityResourcesDialogDirective]
})
export class DashboardLayoutSidebarComponent {
  private readonly dashboardLayoutService = inject(DashboardLayoutService);

  get navMenuItems(): NavMenuItem[] {
    return this.dashboardLayoutService.navMenuItems;
  }
}
